/* eslint-disable default-param-last */
import { Reducer } from 'redux';
import produce from 'immer';
import { MyAccountTypes, MyAccountState } from './types';

const INITIAL_STATE: MyAccountState = {
  my_account: {
    user: {
      contact_client: {
        ativo: false,
        ddd_celular: '',
        ddd_telefone: '',
        email: '',
        genre: {
          id: 0,
          nome: '',
        },
        id: 0,
        nome: '',
        numero_celular: '',
        numero_telefone: '',
        role: {
          id: 0,
          nome: '',
        },
      },
      id: 0,
      email: '',
      nome: '',
      ativo: false,
    },
    has_register_in_authentication: false,
    documents_push_notification: false,
    documents_email_notification: false,
    documents_notification: false,
    eligible_beta_tester_program: false,
    no_bulletin_email_notification: false,
    no_bulletin_push_notification: false,
    beta_tester: true,
    no_notification_bw: true,
    notification_status: false,
    notification_nome: '',
    users: [],
    current_sale: {
      servicos_planos_vendas: [],
      valor_total: '',
      valor_variacao_forma_pagamento: '',
      formas_pagamento: {
        nome: '',
      },
      parcelas: '',
      id: 0,
      status_pagamento: [],
    },
    status_pagamento: false,
    valor_parcela: '',
    scheduled_sale: {
      id: 0,
      valor_total: '',
      servicos_planos_vendas: [],
      valor_variacao_forma_pagamento: '',
      formas_pagamento: {
        nome: '',
      },
      parcelas: 0,
      status_pagamento: [],
    },
    cargo_name: '',
    email: '',
    name: '',
    cel_ddd: '',
    cel_number: '',
    return_modal_sucesso: false,
    exclusionModal: false,
    solicitation_list: [],
    my_filters: [],
    filters_client: [],
    users_filters: [],
    incomes: [],
    future_sale_invoice_incomes: [],
    viewComponent: 'usuario',
    modalSuccess: false,
  },
  request: {
    get_info_user: {
      loading: false,
      loaded: false,
      error: false,
    },
    destroy_user: {
      loading: false,
      loaded: false,
      error: false,
    },
    create_user: {
      loading: false,
      loaded: false,
      error: false,
    },
    users: {
      loading: false,
      loaded: false,
      error: false,
    },
    current_sale: {
      loading: false,
      loaded: false,
      error: false,
    },
    scheduled_sale: {
      loading: false,
      loaded: false,
      error: false,
    },
    pending_incomes: {
      loading: false,
      loaded: false,
      error: false,
    },
    get_incomes: {
      loading: false,
      loaded: false,
      error: false,
    },
    edit_user: {
      loading: false,
      loaded: false,
      error: false,
    },
    solicitation_edition: {
      loading: false,
      loaded: false,
      error: false,
    },
    solicitation_list: {
      loading: false,
      loaded: false,
      error: false,
    },
    user_add: {
      loading: false,
      loaded: false,
      error: false,
    },
    my_filters: {
      loading: false,
      loaded: false,
      error: false,
    },
    incomes: {
      loading: false,
      loaded: false,
      error: false,
    },
  },
};

const reducer: Reducer<MyAccountState> = (
  state = INITIAL_STATE,
  { type, result, view, modal_success },
) => {
  return produce(state, (draft) => {
    switch (type) {
      case MyAccountTypes.GET_INFO_USER_REQUEST:
        draft.request.get_info_user = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;

      case MyAccountTypes.GET_INFO_USER_SUCCESS:
        draft.my_account.no_notification_bw = !result?.data?.no_notification_bw;
        draft.my_account.user = result?.data?.user;
        draft.my_account.beta_tester = result?.data?.beta_tester;
        draft.my_account.documents_notification = result?.data?.documents_notification;
        draft.my_account.documents_email_notification = result?.data?.documents_email_notification;
        draft.my_account.documents_push_notification = result?.data?.documents_push_notification;
        draft.my_account.no_bulletin_email_notification =
          result?.data?.no_bulletin_email_notification;
        draft.my_account.no_bulletin_push_notification =
          result?.data?.no_bulletin_push_notification;
        draft.request.get_info_user = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case MyAccountTypes.GET_INFO_USER_FAILURE:
        draft.request.get_info_user = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case MyAccountTypes.CREATE_USER_PREFERENCES_REQUEST:
        draft.request.create_user = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case MyAccountTypes.CREATE_USER_PREFERENCES_SUCCESS:
        window.location.reload();
        draft.request.create_user = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case MyAccountTypes.DESTROY_USER_PREFERENCES_REQUEST:
        draft.request.destroy_user = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case MyAccountTypes.DESTROY_USER_PREFERENCES_SUCCESS:
        window.location.reload();
        draft.request.destroy_user = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case MyAccountTypes.GET_USERS_REQUEST:
        draft.request.users = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case MyAccountTypes.GET_USERS_SUCCESS:
        draft.my_account.users = result?.data?.users;
        draft.request.users = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case MyAccountTypes.GET_USERS_FAILURE:
        draft.request.users = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case MyAccountTypes.GET_CURRENT_SALE_REQUEST:
        draft.request.current_sale = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case MyAccountTypes.GET_CURRENT_SALE_SUCCESS:
        draft.my_account.current_sale = result?.data;
        draft.request.current_sale = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case MyAccountTypes.GET_CURRENT_SALE_FAILURE:
        draft.my_account = INITIAL_STATE.my_account;
        draft.request.current_sale = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case MyAccountTypes.GET_SCHEDULED_SALE_REQUEST:
        draft.request.scheduled_sale = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case MyAccountTypes.GET_SCHEDULED_SALE_SUCCESS:
        draft.my_account.scheduled_sale = result?.data;
        draft.request.scheduled_sale = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case MyAccountTypes.GET_SCHEDULED_SALE_FAILURE:
        draft.request.scheduled_sale = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case MyAccountTypes.GET_PENDING_INCOMES_REQUEST:
        draft.request.pending_incomes = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case MyAccountTypes.GET_PENDING_INCOMES_SUCCESS:
        draft.my_account.status_pagamento = result?.data;
        draft.request.pending_incomes = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case MyAccountTypes.GET_PENDING_INCOMES_FAILURE:
        draft.request.pending_incomes = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case MyAccountTypes.GET_INCOMES_REQUEST:
        draft.request.get_incomes = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case MyAccountTypes.GET_INCOMES_SUCCESS:
        draft.my_account.valor_parcela = result?.data[0]?.valor_total;
        draft.request.get_incomes = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case MyAccountTypes.GET_INCOMES_FAILURE:
        draft.request.get_incomes = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case MyAccountTypes.GET_EDIT_USER_REQUEST:
        draft.request.edit_user = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case MyAccountTypes.GET_EDIT_USER_SUCCESS:
        draft.my_account.cargo_name = result?.data?.cargo;
        draft.my_account.name = result?.data?.users?.nome;
        draft.my_account.email = result?.data?.users?.email;
        draft.my_account.cel_ddd = result?.data?.users?.ddd_celular;
        draft.my_account.cel_number = result?.data?.users?.numero_celular;
        draft.request.edit_user = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case MyAccountTypes.GET_EDIT_USER_FAILURE:
        draft.request.edit_user = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case MyAccountTypes.GET_SOLICITATION_EDITION_REQUEST:
        draft.request.solicitation_edition = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case MyAccountTypes.GET_SOLICITATION_EDITION_SUCCESS:
        draft.my_account.return_modal_sucesso = result?.data?.success;
        draft.request.solicitation_edition = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case MyAccountTypes.GET_SOLICITATION_EDITION_FAILURE:
        draft.request.solicitation_edition = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case MyAccountTypes.OPEN_EXCLUSION_MODAL:
        draft.my_account.exclusionModal = true;
        break;
      case MyAccountTypes.CLOSE_EXCLUSION_MODAL:
        draft.my_account.exclusionModal = false;
        break;
      case MyAccountTypes.GET_SOLICITATION_LIST_REQUEST:
        draft.request.solicitation_list = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case MyAccountTypes.GET_SOLICITATION_LIST_SUCCESS:
        draft.my_account.solicitation_list = result?.data?.solicitations;
        draft.request.solicitation_list = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case MyAccountTypes.GET_SOLICITATION_LIST_FAILURE:
        draft.request.solicitation_list = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case MyAccountTypes.GET_SOLICITATION_ADDITION_REQUEST:
        draft.request.user_add = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case MyAccountTypes.GET_SOLICITATION_ADDITION_SUCCESS:
        draft.request.user_add = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case MyAccountTypes.GET_SOLICITATION_ADDITION_FAILURE:
        draft.request.user_add = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case MyAccountTypes.GET_BOLETOS_ONLINE_REQUEST:
        draft.request.incomes = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case MyAccountTypes.GET_BOLETOS_ONLINE_SUCCESS:
        draft.my_account.incomes = result?.data?.current_sale_invoice;
        draft.my_account.future_sale_invoice_incomes = result?.data?.future_sale_invoice_incomes;

        draft.request.incomes = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case MyAccountTypes.GET_BOLETOS_ONLINE_FAILURE:
        draft.request.incomes = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case MyAccountTypes.GET_MY_FILTERS_REQUEST:
        draft.request.my_filters = {
          loading: true,
          loaded: false,
          error: false,
        };
        break;
      case MyAccountTypes.GET_MY_FILTERS_SUCCESS:
        draft.my_account.my_filters = result?.data?.filtros;
        draft.my_account.filters_client = result?.data?.filtros_client;
        draft.my_account.users_filters = result?.data?.users_filters;
        draft.request.my_filters = {
          loading: false,
          loaded: true,
          error: false,
        };
        break;
      case MyAccountTypes.GET_MY_FILTERS_FAILURE:
        draft.request.my_filters = {
          loading: false,
          loaded: false,
          error: true,
        };
        break;
      case MyAccountTypes.VIEW_COMPONENT:
        draft.my_account.viewComponent = view;
        break;
      case MyAccountTypes.MODAL_SUCCESS:
        draft.my_account.modalSuccess = modal_success;
        break;
      default:
    }
  });
};

export default reducer;
